// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Company extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Company";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      name: null,
      email: null,
      coachingSurveyDays:null,
      motivationSurveyDays:null,
      feedbackFrequency:null,
      terminology:null,
      companyPassword:null,
      enterpriseType:null,
      themeColor:null,
      secondaryColor:null,
      status: null,
      createdAt: null,
      updatedAt: null
    };
  }
}
const servicePath = "company";
const servicePlugin = makeServicePlugin({
  Model: Company,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
